module.exports = __webpack_public_path__ + "static/media/trezor.9de85cd4.svg";